<template>
  <footer class="page-footer">
    <p>© {{ getYear }} - Ondřej Havle Webdesign and Development</p>
  </footer>
</template>
<script>
export default {
  computed: {
    getYear() {
      let date = new Date();
      return date.getFullYear();
    }
  }
};
</script>
<style lang="scss" scoped>
.page-footer {
  p {
    color: #fff;
    background-color: #000;
    font-size: 0.8rem;
    padding: 0.3rem;
  }
}
</style>
